import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { MapPin, Phone, Mail, Globe, Calendar, FileText, Award, Users, Lightbulb, Target, Zap, Shield, Heart } from 'lucide-react';
import Layout from '../components/Layout';
import PageBanner from '../components/Banner';

const ACCENT = '#E8611A';
const CARD_ACCENTS = [ACCENT, '#3b82f6', '#16a34a', '#7c3aed', '#0891b2', '#f59e0b'];

const ficheData = [
  { label: 'Dénomination',       value: 'Aydees',                          icon: Award },
  { label: 'Date de création',   value: 'Avril 2010',                      icon: Calendar },
  { label: 'Statut juridique',   value: 'SARLU',                           icon: FileText },
  { label: 'Registre',           value: 'RCCM-NI-NIM-2010-B-898',          icon: FileText },
  { label: 'NIF',                value: '16964/R',                          icon: FileText },
  { label: 'Adresse',            value: 'BP 157, Blvd Tanimoune, Niamey',  icon: MapPin },
  { label: 'Téléphone',          value: '(+227) 20 32 01 52 / 96 46 46 33',icon: Phone },
  { label: 'Site web',           value: 'www.aydees.com',                   icon: Globe },
  { label: 'Courriel',           value: 'info@aydees.com',                  icon: Mail },
];

const secteurs = [
  {
    icon: Zap,
    title: 'Informatique & TIC',
    color: ACCENT,
    bg: '#fff7ed',
    items: [
      'Génie logiciel & vente de logiciels',
      'Matériels informatiques & électroniques',
      'Création & hébergement de sites web',
      'Bases de données & VSAT',
      'Formation informatique',
    ],
  },
  {
    icon: Users,
    title: 'Ressources Humaines & Formation',
    color: '#3b82f6',
    bg: '#eff6ff',
    items: [
      'Recrutement & publication d\'offres d\'emploi',
      'Assistance en recrutement',
      'Conseil en gestion de carrière',
      'Plateforme NigerEmploi.com',
    ],
  },
  {
    icon: Target,
    title: 'Études & Conseils en Développement',
    color: '#16a34a',
    bg: '#f0fdf4',
    items: [
      'Santé & population',
      'Éducation',
      'Évaluation & gestion de projet',
      'Conseil en développement',
    ],
  },
];

const valeurs = [
  { icon: Shield,     label: 'Intégrité',     desc: 'Transparence et honnêteté dans chaque engagement',      color: ACCENT },
  { icon: Lightbulb, label: 'Innovation',     desc: 'Solutions modernes adaptées aux défis d\'aujourd\'hui', color: '#3b82f6' },
  { icon: Zap,       label: 'Agilité',        desc: 'Réactivité et adaptabilité face à vos besoins',         color: '#16a34a' },
  { icon: Users,     label: 'Esprit d\'équipe',desc: 'Collaboration et synergie au service de vos projets',  color: '#7c3aed' },
  { icon: Target,    label: 'Excellence',     desc: 'Engagement vers les plus hauts standards de qualité',   color: '#0891b2' },
  { icon: Heart,     label: 'Engagement',     desc: 'Dévouement total à la satisfaction de nos clients',     color: '#f59e0b' },
];

const InfoCard = ({ label, value, icon: Icon, accent }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: '#fff', borderRadius: 14, padding: '16px 18px',
        border: hovered ? `1.5px solid ${accent}40` : '1.5px solid rgba(0,0,0,0.06)',
        boxShadow: hovered ? '0 8px 24px rgba(0,0,0,0.09)' : '0 2px 8px rgba(0,0,0,0.04)',
        transition: 'all .2s', display: 'flex', alignItems: 'center', gap: 14,
        fontFamily: "'DM Sans',sans-serif",
      }}
    >
      <div style={{ width: 40, height: 40, borderRadius: 10, background: `${accent}15`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        <Icon size={18} color={accent} />
      </div>
      <div>
        <p style={{ fontSize: '0.72rem', color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', margin: 0 }}>{label}</p>
        <p style={{ fontSize: '0.88rem', color: '#1e293b', fontWeight: 600, margin: '2px 0 0' }}>{value}</p>
      </div>
    </div>
  );
};

const ValeurCard = ({ valeur: v }) => {
  const [hov, setHov] = useState(false);
  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        background: '#fff', borderRadius: 16, padding: '22px 20px',
        border: hov ? `1.5px solid ${v.color}40` : '1.5px solid rgba(0,0,0,0.06)',
        boxShadow: hov ? '0 10px 28px rgba(0,0,0,0.09)' : '0 2px 8px rgba(0,0,0,0.04)',
        transition: 'all .22s', transform: hov ? 'translateY(-4px)' : 'none',
        fontFamily: "'DM Sans',sans-serif",
      }}
    >
      <div style={{ width: 46, height: 46, borderRadius: 12, background: hov ? v.color : `${v.color}15`, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14, transition: 'background .22s' }}>
        <v.icon size={20} color={hov ? '#fff' : v.color} />
      </div>
      <h3 style={{ fontSize: '0.95rem', fontWeight: 700, color: '#1e293b', margin: '0 0 6px' }}>{v.label}</h3>
      <p style={{ fontSize: '0.82rem', color: '#64748b', margin: 0, lineHeight: 1.6 }}>{v.desc}</p>
    </div>
  );
};

export function AboutPrposPage() {
  return (
    <Layout>
      <Helmet>
        <title>À Propos - Aydees | Solutions IT & Conseils au Niger</title>
        <meta name="description" content="Découvrez Aydees, cabinet nigérien fondé en 2010 spécialisé dans les TIC, les ressources humaines et les études & conseils en développement." />
        <meta name="keywords" content="à propos Aydees, cabinet IT Niger, solutions informatiques, Niamey, histoire, valeurs" />
      </Helmet>

      <PageBanner
        title="À Propos de Nous"
        subtitle="Votre partenaire technologique de confiance depuis 2010"
      />

      {/* Hero intro */}
      <section style={{ background: 'linear-gradient(135deg,#fff7ed 0%,#ffffff 60%,#f8fafc 100%)', padding: '40px 24px', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, opacity: 0.3, pointerEvents: 'none', backgroundImage: 'radial-gradient(circle,#e2e8f0 1px,transparent 1px)', backgroundSize: '28px 28px' }} />
        <div style={{ position: 'absolute', top: '-10%', right: '5%', width: 320, height: 320, borderRadius: '50%', background: `radial-gradient(circle,${ACCENT}18 0%,transparent 70%)`, filter: 'blur(55px)', pointerEvents: 'none' }} />
        <div style={{ maxWidth: 1100, margin: '0 auto', position: 'relative', zIndex: 1, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'center' }}>
          <div style={{ fontFamily: "'DM Sans',sans-serif" }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '5px 16px', borderRadius: 999, border: `1px solid ${ACCENT}30`, background: `${ACCENT}0d`, marginBottom: 16 }}>
              <span style={{ fontSize: '0.68rem', fontWeight: 700, color: ACCENT, letterSpacing: '0.1em', textTransform: 'uppercase' }}>Depuis 2010</span>
            </div>
            <h2 style={{ fontSize: 'clamp(1.6rem,3vw,2.2rem)', fontWeight: 900, color: '#1e293b', margin: '0 0 16px', lineHeight: 1.2 }}>
              Cabinet <span style={{ color: ACCENT }}>Aydees</span>
            </h2>
            <p style={{ fontSize: '0.95rem', color: '#475569', lineHeight: 1.8, margin: '0 0 16px' }}>
              Anciennement <strong>SM Global Solutions</strong>, Aydees est une Société à Responsabilité Limitée Unipersonnelle fondée en avril 2010 à Niamey, Niger.
            </p>
            <p style={{ fontSize: '0.95rem', color: '#475569', lineHeight: 1.8, margin: '0 0 20px' }}>
              Nous proposons des <strong>solutions innovantes, efficientes, sécurisées et personnalisées</strong> à nos clients : administrations publiques, ONG nationales et internationales, et entreprises privées.
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 20px', borderRadius: 12, background: `${ACCENT}0d`, border: `1px solid ${ACCENT}25` }}>
              <Zap size={20} color={ACCENT} />
              <span style={{ fontSize: '0.92rem', fontWeight: 700, color: ACCENT, fontStyle: 'italic' }}>"Let's go for success"</span>
            </div>
          </div>

          {/* Stats */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            {[
              { val: '15+', label: 'Années d\'expérience', color: ACCENT },
              { val: '3',   label: "Secteurs d'activités", color: '#3b82f6' },
              { val: '100+', label: 'Projets réalisés',    color: '#16a34a' },
              { val: '∞',   label: 'Engagement client',    color: '#7c3aed' },
            ].map((s, i) => (
              <div key={i} style={{ background: '#fff', borderRadius: 16, padding: '20px 16px', textAlign: 'center', border: `1.5px solid ${s.color}20`, boxShadow: '0 2px 10px rgba(0,0,0,0.05)', fontFamily: "'DM Sans',sans-serif" }}>
                <div style={{ fontSize: '2rem', fontWeight: 900, color: s.color, lineHeight: 1 }}>{s.val}</div>
                <div style={{ fontSize: '0.78rem', color: '#64748b', marginTop: 6, fontWeight: 500 }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Fiche d'identité */}
      <section style={{ background: '#f8fafc', padding: '36px 24px' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <h2 style={{ fontSize: 'clamp(1.2rem,2vw,1.6rem)', fontWeight: 800, color: '#1e293b', margin: '0 0 6px', fontFamily: "'DM Sans',sans-serif" }}>Fiche d'Identité</h2>
            <div style={{ width: 32, height: 3, borderRadius: 99, background: `linear-gradient(to right,${ACCENT},${ACCENT}55)`, margin: '0 auto' }} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(260px,1fr))', gap: 10 }}>
            {ficheData.map((item, i) => (
              <InfoCard key={i} {...item} accent={CARD_ACCENTS[i % CARD_ACCENTS.length]} />
            ))}
          </div>
        </div>
      </section>

      {/* Secteurs d'activités */}
      <section style={{ background: '#fff', padding: '36px 24px' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <h2 style={{ fontSize: 'clamp(1.2rem,2vw,1.6rem)', fontWeight: 800, color: '#1e293b', margin: '0 0 6px', fontFamily: "'DM Sans',sans-serif" }}>Secteurs d'Activités</h2>
            <div style={{ width: 32, height: 3, borderRadius: 99, background: `linear-gradient(to right,${ACCENT},${ACCENT}55)`, margin: '0 auto 6px' }} />
            <p style={{ color: '#64748b', fontSize: '0.85rem', fontFamily: "'DM Sans',sans-serif", margin: 0 }}>Trois domaines d'expertise complémentaires</p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(300px,1fr))', gap: 20 }}>
            {secteurs.map((s, i) => (
              <div key={i} style={{ background: s.bg, borderRadius: 14, padding: '20px 18px', border: `1.5px solid ${s.color}20`, fontFamily: "'DM Sans',sans-serif" }}>
                <div style={{ width: 40, height: 40, borderRadius: 10, background: s.color, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 10 }}>
                  <s.icon size={18} color="#fff" />
                </div>
                <h3 style={{ fontSize: '0.92rem', fontWeight: 700, color: '#1e293b', margin: '0 0 10px' }}>{s.title}</h3>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {s.items.map((item, j) => (
                    <li key={j} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: '0.83rem', color: '#475569', lineHeight: 1.5 }}>
                      <span style={{ width: 6, height: 6, borderRadius: '50%', background: s.color, flexShrink: 0, marginTop: 5 }} />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 16, background: `${ACCENT}0a`, borderRadius: 12, padding: '14px 20px', border: `1px solid ${ACCENT}20`, fontFamily: "'DM Sans',sans-serif" }}>
            <p style={{ fontSize: '0.88rem', color: '#475569', lineHeight: 1.8, margin: 0 }}>
              Dans les trois secteurs, nous disposons d'<strong>experts de haut niveau</strong> qui sauront répondre à vos demandes. Nous utilisons des méthodes et outils testés, approuvés et d'une robustesse reconnue à l'échelle internationale. Nos solutions respectent strictement les <strong>normes internationales</strong>.
            </p>
          </div>
        </div>
      </section>

      {/* Valeurs */}
      <section style={{ background: 'linear-gradient(135deg,#fff7ed 0%,#f8fafc 100%)', padding: '36px 24px', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, opacity: 0.3, pointerEvents: 'none', backgroundImage: 'radial-gradient(circle,#e2e8f0 1px,transparent 1px)', backgroundSize: '28px 28px' }} />
        <div style={{ maxWidth: 1100, margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <h2 style={{ fontSize: 'clamp(1.2rem,2vw,1.6rem)', fontWeight: 800, color: '#1e293b', margin: '0 0 6px', fontFamily: "'DM Sans',sans-serif" }}>Nos Valeurs & Atouts</h2>
            <div style={{ width: 32, height: 3, borderRadius: 99, background: `linear-gradient(to right,${ACCENT},${ACCENT}55)`, margin: '0 auto 6px' }} />
            <p style={{ color: '#64748b', fontSize: '0.85rem', fontFamily: "'DM Sans',sans-serif", margin: 0 }}>Les principes qui guident chacune de nos actions</p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(240px,1fr))', gap: 14 }}>
            {valeurs.map((v, i) => <ValeurCard key={i} valeur={v} />)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ background: 'linear-gradient(135deg,#0f172a 0%,#1e293b 100%)', padding: '44px 24px', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, background: `${ACCENT}12`, pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', top: '-20%', right: '5%', width: 340, height: 340, borderRadius: '50%', background: `radial-gradient(circle,${ACCENT}20 0%,transparent 70%)`, filter: 'blur(60px)', pointerEvents: 'none' }} />
        <div style={{ maxWidth: 640, margin: '0 auto', textAlign: 'center', position: 'relative', zIndex: 1, fontFamily: "'DM Sans',sans-serif" }}>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 20 }}>
            {[
              { label: 'Administrations publiques', color: ACCENT },
              { label: 'ONG nationales & internationales', color: '#3b82f6' },
              { label: 'Entreprises privées', color: '#16a34a' },
            ].map((c, i) => (
              <div key={i} style={{ padding: '6px 16px', borderRadius: 999, background: `${c.color}20`, border: `1px solid ${c.color}40`, fontSize: '0.8rem', fontWeight: 600, color: '#fff' }}>
                {c.label}
              </div>
            ))}
          </div>
          <h2 style={{ fontSize: 'clamp(1.3rem,2.5vw,1.8rem)', fontWeight: 800, color: '#fff', margin: '0 0 10px' }}>Travaillons ensemble</h2>
          <p style={{ color: '#94a3b8', fontSize: '0.9rem', margin: '0 0 20px', lineHeight: 1.7 }}>Contactez-nous pour discuter de vos projets et découvrir comment Aydees peut vous accompagner.</p>
          <a
            href="mailto:info@aydees.com"
            onMouseEnter={e => { e.currentTarget.style.background = '#d4501a'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = ACCENT; e.currentTarget.style.transform = 'none'; }}
            style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '13px 28px', borderRadius: 10, background: ACCENT, color: '#fff', fontWeight: 700, fontSize: '0.9rem', textDecoration: 'none', transition: 'background .2s, transform .2s', boxShadow: `0 6px 20px ${ACCENT}40` }}
          >
            <Mail size={17} /> Contactez-nous
          </a>
        </div>
      </section>
    </Layout>
  );
}

export default AboutPrposPage;